import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';

/**
 * Service Chronos™ Badge Components
 * Displays badges indicating 24h express fabrication service
 */

// Badge petit pour vignettes produit - Style Horloge
export const ChronoBadgeSmall = ({ className = '' }) => (
  <Link 
    to="/service-chronos"
    onClick={(e) => e.stopPropagation()}
    className={`absolute top-2 right-2 bg-orange-500 hover:bg-orange-600 text-white px-2 py-1 rounded-full text-xs font-bold flex items-center gap-1 shadow-md z-10 transition-colors ${className}`}
    title="Service Chronos™ - Fabrication 24h"
  >
    <Clock className="w-3 h-3" />
    <span>24H</span>
  </Link>
);

// Badge moyen pour fiche produit
export const ChronoBadgeMedium = ({ showLink = true }) => (
  <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
    <div className="flex items-start gap-3">
      <div className="bg-orange-500 p-2 rounded-full">
        <Clock className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1">
        <h4 className="font-semibold text-gray-900 mb-1">
          Service Chronos™ - Fabrication 24h
        </h4>
        <p className="text-sm text-gray-600 mb-2">
          Commande traitée en priorité, expédiée sous 24h ouvrées.
        </p>
        {showLink && (
          <Link 
            to="/service-chronos" 
            className="text-sm text-orange-600 hover:underline font-medium"
          >
            Conditions et toiles éligibles →
          </Link>
        )}
      </div>
    </div>
  </div>
);

// Bannière pour panier/checkout
export const ChronoBanner = () => (
  <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg p-4 mb-4">
    <div className="flex items-center gap-3">
      <Clock className="w-8 h-8 flex-shrink-0" />
      <div>
        <p className="font-semibold">Service Chronos™ - Fabrication express</p>
        <p className="text-sm opacity-90">
          Cette toile est éligible à la fabrication en 24h.{' '}
          <Link to="/service-chronos" className="underline hover:no-underline">
            Voir les conditions
          </Link>
        </p>
      </div>
    </div>
  </div>
);

export default ChronoBadgeSmall;
